<template>
  <FacilityAttribute :blok="blok" />
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
});
</script>